const Mascaras = {
  cpf: '999.999.999-99',
  cep: '99.999-999',
  telefone: '(99) 9999-9999',
  celular: '(99) 99999-9999',
};

export { Mascaras };
